export const VIRTUAL_INDICATION_TYPES = ["forms", "program"];

export function filterPersistibleIndications(savedIndications, typeFilter) {
  const allowed =
    typeFilter && typeFilter.length > 0 ? new Set(typeFilter) : null;
  return savedIndications.filter((ind) => {
    if (VIRTUAL_INDICATION_TYPES.includes(ind.type)) return false;
    if (allowed && !allowed.has(ind.type)) return false;
    return !ind.createdAt;
  });
}
